import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@utils/cn';

import type { SliderBarProps } from './Slider.types';

import {
  sliderBarRangeClasses,
  sliderBarRootClasses,
  sliderBarThumbClasses,
  sliderBarTrackClasses
} from './SliderBar.styles';

const SliderBar = ({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  onValueChange,
  onValueCommit,
  ...props
}: SliderBarProps) => {
  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn(sliderBarRootClasses(), className)}
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      onValueChange={onValueChange}
      onValueCommit={onValueCommit}
      {...props}
    >
      <SliderPrimitive.Track className={cn(sliderBarTrackClasses())}>
        <SliderPrimitive.Range className={cn(sliderBarRangeClasses())} />
      </SliderPrimitive.Track>
      {(value ?? defaultValue ?? [min]).map((_, index) => (
        <SliderPrimitive.Thumb key={index} className={cn(sliderBarThumbClasses())} />
      ))}
    </SliderPrimitive.Root>
  );
};

export { SliderBar };
